import { CMMS_TECHNICIAN_ROLES } from "./cmmsRoles";

const toOption = (user) => ({ id: user.id, title: user.name ?? user.username ?? `#${user.id}` });

const isTechnician = (user) => (user.roles ?? []).some((roleId) => CMMS_TECHNICIAN_ROLES.includes(roleId));

/**
 * Options for an "assigned to" picker: the people who can actually do the work, which is
 * the Cmms_Technician tier (Technician + Admin). /api/users answers with everyone, and
 * offering an operator here hands them a job they are not allowed to claim or complete.
 *
 * currentId is the form's current assignee. It stays in the list even when it falls
 * outside the tier — a work order assigned before this filter existed would otherwise
 * render an empty field while the old id rode along in form state and was saved back
 * unseen. Pass the live form value, not the id saved on the record: once the field is
 * cleared or changed, a non-technician drops out and cannot be picked again.
 */
export function toAssigneeOptions(users, currentId) {
  return (users ?? [])
    .filter((user) => isTechnician(user) || (currentId != null && user.id === currentId))
    .map(toOption);
}
